export default {
  methods: {
    getDescriptionSheetIcon(description) {
      const { icon, categoryId, category } = description;
      if (icon) {
        return icon;
      } else {
        let cateIcon = "";
        category.subCategories.forEach((subCategory) => {
          const { subCategories } = subCategory;
          const cate = subCategories.find(
            (subCate) => subCate.id === categoryId
          );
          cateIcon = cate && cate.icon ? cate.icon : subCategory.icon;
        });
        return cateIcon;
      }
    },
    getCategoryPath(description) {
      const { categoryId, category } = description;
      let catePath = category.name;
      category.subCategories.forEach((subCategory) => {
        if (subCategory.subCategories.length) {
          subCategory.subCategories.forEach((item) => {
            if (item.id === categoryId) {
              catePath += ` > ${subCategory.name} > ${item.name}`;
            }
          })
        } else if (subCategory.id === categoryId) {
          catePath += ` > ${subCategory.name}`;
        }
      })
      return catePath;
    },
  }
};
